<template>
  <Menu as="div" class="relative inline-block text-left">
    <MenuButton
      class="relative pl-5 pr-10 min-w-[120px] inline-flex justify-start w-full py-2 border border-light-divider-border dark:border-dark-divider-border rounded-lg shadow-md text-light-body-text dark:text-dark-body-text placeholder-common-grey focus:outline-none focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue text-sm transition ease-in-out duration-side-menu-transition-duration"
      @click="show_menu = true">
      <span :class="{ 'text-common-grey': !selected_relative_date }">
        {{ selected_relative_date?.label ? selected_relative_date?.label : "Select Range" }}
      </span>

      <span class="absolute inset-y-0 flex items-center pointer-events-none right-2">
        <ChevronDown class="w-5 h-5 text-common-grey" aria-hidden="true" />
      </span>
    </MenuButton>

    <div>
      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0">
        <MenuItems
          class="absolute bottom-0 right-0 z-50 grid grid-cols-3 origin-bottom-right bg-white rounded-md shadow-lg dark:bg-dark-screen-background ring-1 ring-black ring-opacity-5 focus:outline-none">
          <MenuItem v-if="selected_relative_date" v-slot="{ active }" class="col-span-3">
            <div
              :class="[
                active ? 'bg-gray-100 dark:bg-dark-screen-background text-gray-400' : 'text-gray-700 dark:text-dark-body-text',
                ' cursor-pointer group flex justify-center items-center p-2 text-sm'
              ]"
              @click="
                () => {
                  selected_relative_date = null
                }
              ">
              {{ $t("Clear") }}
            </div>
          </MenuItem>

          <MenuItem v-for="item in relative_dates" :key="item.name" v-slot="{ active }" class="col-span-1">
            <div
              :disabled="item.disabled"
              :class="[
                active ? 'bg-gray-100 dark:bg-dark-screen-background text-gray-400' : 'text-gray-700 dark:text-dark-body-text',
                ' cursor-pointer group flex justify-center items-center p-2 text-sm',
                { 'bg-blue text-white': selected_relative_date && selected_relative_date?.value == item?.value }
              ]"
              @click="
                () => {
                  selected_relative_date = item
                }
              ">
              {{ item.label }}
            </div>
          </MenuItem>
        </MenuItems>
      </transition>
    </div>
  </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"
import { ChevronDown } from "lucide-vue-next"
export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ChevronDown
  },
  props: {
    selectedRelativeDate: {
      type: String,
      default: ""
    }
  },
  emits: ["update:selectedRelativeDate"],
  data() {
    return {
      relative_dates: [
        {
          label: this.$t("Today"),
          value: "today",
          start: this.$moment().startOf("day").toDate(),
          end: this.$moment().endOf("day").toDate()
        },
        {
          label: this.$t("Tomorrow"),
          value: "tomorrow",
          start: this.$moment().add(1, "day").startOf("day").toDate(),
          end: this.$moment().add(1, "day").endOf("day").toDate()
        },
        {
          label: this.$t("Yesterday"),
          value: "yesterday",
          start: this.$moment().subtract(1, "day").startOf("day").toDate(),
          end: this.$moment().subtract(1, "day").endOf("day").toDate()
        },
        {
          label: this.$t("This Week"),
          value: "this_week",
          start: this.$moment().startOf("week").toDate(),
          end: this.$moment().endOf("week").toDate()
        },
        {
          label: this.$t("Next Week"),
          value: "next_week",
          start: this.$moment().add(1, "week").startOf("week").toDate(),
          end: this.$moment().add(1, "week").endOf("week").toDate()
        },
        {
          label: this.$t("Last Week"),
          value: "last_week",
          start: this.$moment().subtract(1, "week").startOf("week").toDate(),
          end: this.$moment().subtract(1, "week").endOf("week").toDate()
        },
        {
          label: this.$t("This Month"),
          value: "this_month",
          start: this.$moment().startOf("month").toDate(),
          end: this.$moment().endOf("month").toDate()
        },
        {
          label: this.$t("Next Month"),
          value: "next_month",
          start: this.$moment().add(1, "month").startOf("month").toDate(),
          end: this.$moment().add(1, "month").endOf("month").toDate()
        },
        {
          label: this.$t("Last Month"),
          value: "last_month",
          start: this.$moment().subtract(1, "month").startOf("month").toDate(),
          end: this.$moment().subtract(1, "month").endOf("month").toDate()
        },
        {
          label: this.$t("This Quarter"),
          value: "this_quarter",
          start: this.$moment().startOf("quarter").toDate(),
          end: this.$moment().endOf("quarter").toDate()
        },
        {
          label: this.$t("Next Quarter"),
          value: "next_quarter",
          start: this.$moment().add(1, "quarter").startOf("quarter").toDate(),
          end: this.$moment().add(1, "quarter").endOf("quarter").toDate()
        },
        {
          label: this.$t("Last Quarter"),
          value: "last_quarter",
          start: this.$moment().subtract(1, "quarter").startOf("quarter").toDate(),
          end: this.$moment().subtract(1, "quarter").endOf("quarter").toDate()
        },
        {
          label: this.$t("This Year"),
          value: "this_year",
          start: this.$moment().startOf("year").toDate(),
          end: this.$moment().endOf("year").toDate()
        },
        {
          label: this.$t("Next Year"),
          value: "next_year",
          start: this.$moment().add(1, "year").startOf("year").toDate(),
          end: this.$moment().add(1, "year").endOf("year").toDate()
        },
        {
          label: this.$t("Last Year"),
          value: "last_year",
          start: this.$moment().subtract(1, "year").startOf("year").toDate(),
          end: this.$moment().subtract(1, "year").endOf("year").toDate()
        }
      ],
      selected_relative_date: null,
      show_menu: false
    }
  },
  watch: {
    selectedRelativeDate: {
      deep: true,
      handler() {
        this.selected_relative_date = this.relative_dates.find((relative_date) => relative_date.value == this.selectedRelativeDate)
      }
    },
    selected_relative_date: {
      deep: true,
      handler() {
        this.$emit("update:selectedRelativeDate", this.selected_relative_date ? this.selected_relative_date.value : null)
      }
    }
  },
  created() {
    if (this.selectedRelativeDate) {
      this.selected_relative_date = this.relative_dates.find((relative_date) => relative_date.value == this.selectedRelativeDate)
    }
  }
}
</script>
